<template>
  <div>
    <observation/>
    <assessment
      :current-participant="currentParticipant"
      :current-exercise="currentExercise"
      :current-matrix='runInfo.competencyExerciseMatrix.filter((ce) => ce.exerciseId === currentExerciseId)'
      @saveWithDelay='saveWithDelay'/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Assessment from '../components/Assessment';
import Observation from '../components/Observation';
import ACTIONS from '../storeActions';
import { EventBus, EVENTS } from '../libs/eventBus';

export default {
  name: 'RatingPage',
  components: {
    Observation,
    Assessment,
  },
  computed: {
    ...mapGetters(['currentExercise', 'currentParticipant', 'syncFromAppToCockpitAllowed', 'currentObserver', 'isGuestObserver']),
    ...mapState(['currentParticipantId', 'currentExerciseId', 'assessments', 'currentInterviewId', 'runInfo']),
  },
  data: () => ({
    saveTimer: {}
  }),
  methods: {
    saveWithDelay(assessment) {
      console.log('MixedPage: saveWithDelay')
      const self = this;
      self.assessmentsToSave[assessment.temporaryId] = assessment
      if (self.saveTimer[assessment.temporaryId]) {
        clearTimeout(self.saveTimer[assessment.temporaryId]);
        self.saveTimer[assessment.temporaryId] = undefined
      }
      self.saveTimer[assessment.temporaryId] = setTimeout(() => {
        self.save(assessment.temporaryId)
      }, 3000);
    },
    save(assessment) {
      const self = this;
      const handleSave = (method, items) => {
        if (!this.syncFromAppToCockpitAllowed || this.isGuestObserver) {
          console.warn('Skipping sync - not allowed currently');
          const update = Array.isArray(items) ? items : [items]
          self.$store.dispatch(ACTIONS.UPDATE_ASSESSMENTS, { current: update, response: update })
          return;
        }
        self.$apiRequest[method]('/assessments', Array.isArray(items) ? items : [items])
          .then((data) => self.$store.dispatch(ACTIONS.UPDATE_ASSESSMENTS, { current: Array.isArray(items) ? items : [items], response: data }))
          .catch((err) => {
            console.error(err);
            self.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: self.$t('Errors.unknown'), color: 'error' })
          }).finally(() => {
            if (Array.isArray(items)) {
              if (items.length <= 0) return;
              for (const item of items) {
                if (self.assessmentsToSave[item.temporaryId]) delete self.assessmentsToSave[item.temporaryId]
              }
            } else if (self.assessmentsToSave[items.temporaryId]) delete self.assessmentsToSave[items.temporaryId]
        })
      }
      if (!assessment) {
        const modified = [];
        Object.keys(self.saveTimer).forEach((key) => {
          if ( self.saveTimer[key] === undefined ) return;
          clearTimeout(self.saveTimer[key]);
          self.saveTimer[key] = undefined;
          modified.push(this.assessments.find((a) => a.id === key || a.temporaryId === key));
        })
        const toCreate = modified.filter( (m) => !m.loaded );
        const toUpdate = modified.filter( (m) => m.loaded );
        if (toCreate.length > 0) handleSave('post', toCreate);
        if (toUpdate.length > 0) handleSave('put', toUpdate);
        return
      }
      if (self.saveTimer[assessment.temporaryId]) {
        clearTimeout(self.saveTimer[assessment.temporaryId])
        self.saveTimer[assessment.temporaryId] = undefined;
      }
      handleSave(assessment.loaded ? 'put' : 'post', assessment)
    }
  },
  mounted() {
    if (this.currentInterviewId) this.$router.push({ name: 'interview' })
    if (!this.currentParticipantId || !this.currentExerciseId) {
      this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.$i18n.t('Errors.noExerciseSelected'), color: 'error' } );
      this.$router.push({ name: 'overview' });
    }
  },
};
</script>
